import { useCallback, useEffect, useState } from 'react';
import { UserData } from '../types/User.types';

// Fetches the real user catalog from GET /list. Used by pickers (e.g. group
// membership) that need the full roster rather than a paginated table.
export const useApiUsers = () => {
  const [users, setUsers] = useState<UserData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const Cookies = (await import('universal-cookie')).default;
      const cookies = new Cookies();
      const userCookie = cookies.get('101Obex');
      if (!userCookie || !userCookie.token) {
        setError(true);
        return;
      }

      const url = `/list?page=1&page_size=200&access_token=${encodeURIComponent(userCookie.token)}`;

      const ObexRequestsHandlerP80 = (await import('../handlers/ObexRequestsHandlerP80')).default;
      let res = await ObexRequestsHandlerP80.get(url);
      if (res.data) res = res.data;

      const usersData = res?.response?.data || (Array.isArray(res?.response) ? res.response : res?.result?.response?.data);
      if (Array.isArray(usersData)) {
        setUsers(usersData.map((u: any) => ({
          id: String(u.id),
          name: `${u.name} ${u.last_name || ''}`.trim(),
          firstName: u.name || '',
          lastName: u.last_name || '',
          email: u.email,
          role: 'viewer', // placeholder — the API doesn't return a per-user role yet
          status: u.status as any,
          lastLogin: u.created_at || new Date().toISOString(),
          department: 'IT',
          supervisorId: u.supervisor_id !== null && u.supervisor_id !== undefined ? String(u.supervisor_id) : null,
          isDefaultSupervisor: u.is_default_supervisor === true
        })));
      } else {
        setError(true);
      }
    } catch (fetchError) {
      console.error('Error fetching users:', fetchError);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error, reload: fetchUsers };
};
